module.exports = __webpack_public_path__ + "e83fa9aa6c77ba5627f5ebc47cb435f9.pdf";